module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousJobView
    }
  }, [_vm._v(" Back")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('h2', [_c('b', [_vm._v(_vm._s(_vm.editVar.FormVal) + " Job Order")])])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Service Estimation No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "serviceEstSeries",
      "name": "serviceEstSeries",
      "disabled": true
    },
    model: {
      value: (_vm.jobOrderTpt.serviceEstSeries),
      callback: function($$v) {
        _vm.$set(_vm.jobOrderTpt, "serviceEstSeries", $$v)
      },
      expression: "jobOrderTpt.serviceEstSeries"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "showMoreData success mt-2",
    on: {
      "click": _vm.showMore
    }
  }, [_vm._v("Click here " + _vm._s(_vm.showMoreNew == true ? " To Hide" : " For Show") + " PO Details")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Service Estimation Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "disabled": true,
      "id": "Date"
    },
    model: {
      value: (_vm.jobOrderTpt.serviceEstimationDate),
      callback: function($$v) {
        _vm.$set(_vm.jobOrderTpt, "serviceEstimationDate", $$v)
      },
      expression: "jobOrderTpt.serviceEstimationDate"
    }
  })], 1)], 1), _vm._v(" "), (_vm.showMoreNew == true) ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "jobOrderTpt"
    }
  }, [_vm._v("Mainteinance Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.MaintainList,
      "isDisabled": "",
      "option-value": "MVal",
      "option-text": "MText",
      "placeholder": "Select  Type"
    },
    model: {
      value: (_vm.jobOrderTpt.maintenanceType),
      callback: function($$v) {
        _vm.$set(_vm.jobOrderTpt, "maintenanceType", $$v)
      },
      expression: "jobOrderTpt.maintenanceType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Supervisor Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "requestedBy",
      "name": "requestedBy",
      "disabled": true
    },
    model: {
      value: (_vm.jobOrderTpt.requestedBy),
      callback: function($$v) {
        _vm.$set(_vm.jobOrderTpt, "requestedBy", $$v)
      },
      expression: "jobOrderTpt.requestedBy"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Approved By")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "approvedBy",
      "name": "approvedBy",
      "disabled": true
    },
    model: {
      value: (_vm.jobOrderTpt.approvedBy),
      callback: function($$v) {
        _vm.$set(_vm.jobOrderTpt, "approvedBy", $$v)
      },
      expression: "jobOrderTpt.approvedBy"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.jobOrderTpt.maintenanceType != 'Office' && _vm.showMoreNew == true) ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Vehicle No.")]), _vm._v(" "), (_vm.jobOrderTpt.maintenanceType == 'Vehicle') ? _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "jobOrderTpt",
      "name": "jobOrderTpt",
      "disabled": ""
    },
    model: {
      value: (_vm.jobOrderTpt.vehicleNo),
      callback: function($$v) {
        _vm.$set(_vm.jobOrderTpt, "vehicleNo", $$v)
      },
      expression: "jobOrderTpt.vehicleNo"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jobOrderTpt.maintenanceType == 'Yard') ? _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vehicleNo",
      "name": "vehicleNo",
      "disabled": ""
    },
    model: {
      value: (_vm.jobOrderTpt.vehicleYard),
      callback: function($$v) {
        _vm.$set(_vm.jobOrderTpt, "vehicleYard", $$v)
      },
      expression: "jobOrderTpt.vehicleYard"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Engine No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "engineNo",
      "name": "engineNo",
      "disabled": true
    },
    model: {
      value: (_vm.jobOrderTpt.engineNo),
      callback: function($$v) {
        _vm.$set(_vm.jobOrderTpt, "engineNo", $$v)
      },
      expression: "jobOrderTpt.engineNo"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Chassis No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "chassisNo",
      "name": "chassisNo",
      "disabled": true
    },
    model: {
      value: (_vm.jobOrderTpt.chassisNo),
      callback: function($$v) {
        _vm.$set(_vm.jobOrderTpt, "chassisNo", $$v)
      },
      expression: "jobOrderTpt.chassisNo"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Purchase Year")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "yearOfPurchase",
      "name": "yearOfPurchase",
      "disabled": true
    },
    model: {
      value: (_vm.jobOrderTpt.yearOfPurchase),
      callback: function($$v) {
        _vm.$set(_vm.jobOrderTpt, "yearOfPurchase", $$v)
      },
      expression: "jobOrderTpt.yearOfPurchase"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.jobOrderTpt.maintenanceType != 'Office' && _vm.showMoreNew == true) ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Driver Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "driverName",
      "name": "driverName",
      "disabled": true
    },
    model: {
      value: (_vm.jobOrderTpt.driverName),
      callback: function($$v) {
        _vm.$set(_vm.jobOrderTpt, "driverName", $$v)
      },
      expression: "jobOrderTpt.driverName"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Job Order Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "disabled": _vm.checkStatus,
      "id": "Date"
    },
    model: {
      value: (_vm.jobOrderTpt.jobOrderDate),
      callback: function($$v) {
        _vm.$set(_vm.jobOrderTpt, "jobOrderDate", $$v)
      },
      expression: "jobOrderTpt.jobOrderDate"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Mechanic Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mechanicName",
      "name": "mechanicName",
      "disabled": _vm.checkStatus
    },
    model: {
      value: (_vm.jobOrderTpt.mechanicName),
      callback: function($$v) {
        _vm.$set(_vm.jobOrderTpt, "mechanicName", $$v)
      },
      expression: "jobOrderTpt.mechanicName"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Mechanic Contact")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mechanicContact",
      "name": "mechanicContact",
      "disabled": _vm.checkStatus
    },
    model: {
      value: (_vm.jobOrderTpt.mechanicContact),
      callback: function($$v) {
        _vm.$set(_vm.jobOrderTpt, "mechanicContact", $$v)
      },
      expression: "jobOrderTpt.mechanicContact"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "jobTypeTptStatus"
    }
  }, [_vm._v("Job Order Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "SVal",
      "option-text": "Stxt",
      "placeholder": "Select  Status"
    },
    model: {
      value: (_vm.jobOrderTpt.jobTypeTptStatus),
      callback: function($$v) {
        _vm.$set(_vm.jobOrderTpt, "jobTypeTptStatus", $$v)
      },
      expression: "jobOrderTpt.jobTypeTptStatus"
    }
  }), _vm._v(" "), (!_vm.jobOrderTpt.jobTypeTptStatus) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.statusError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), (_vm.itemServiceDetails.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Requried Item Details")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "stockIntable"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Item Code")]), _vm._v(" "), _c('th', [_vm._v("Item Name")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Creation Date")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itemServiceDetails), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemQuantity))]), _vm._v(" "), (item.iActiveServiceStock == '1') ? _c('td', {
      staticStyle: {
        "color": "#009102"
      }
    }, [_c('b', [_vm._v("Approved")])]) : _c('td', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Not Approved")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.loginTime)))])])
  }))])])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-button",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px mrgtop-2per",
    attrs: {
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addJobOrderTpt
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1e82cb2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/maintenance/jobOrderSheet/jobOrderSheet.vue
// module id = 2888
// module chunks = 0